import React from 'react';

export const butterPreparationLabel = counts => [
  Number(counts?.without_butter_white) > 0 ? `${counts.without_butter_white}x Hell` : null,
  Number(counts?.without_butter_seeded) > 0 ? `${counts.without_butter_seeded}x Korn` : null,
].filter(Boolean).join(' / ');

export default function ButterPreparationNote({counts, compact = false}) {
  const label = butterPreparationLabel(counts);
  if (!label) return null;
  const shortLabel = [
    Number(counts?.without_butter_seeded) > 0 ? `${counts.without_butter_seeded}K` : null,
    Number(counts?.without_butter_white) > 0 ? `${counts.without_butter_white}N` : null,
  ].filter(Boolean).join('/');
  return compact
    ? <span className="block text-[10px] font-normal text-gray-500" title={`ohne Butter: ${label}`}>o. Butter: {shortLabel}</span>
    : <span className="mt-1 block text-xs font-normal text-gray-600">ohne Butter: {label}</span>;
}
